var React = require('react');

function MenuToggle (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"white","fillRule":"evenodd"},React.createElement("polygon",{"id":"path-1","points":"16 7 3.83 7 9.42 1.41 8 0 0 8 8 16 9.41 14.59 3.83 9 16 9"})));
}

MenuToggle.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = MenuToggle;

MenuToggle.default = MenuToggle;
